import { useDynamicConfig } from '@statsig/react-bindings';

/**
 * Statsig `enable_componentization` public_config kill switch.
 * Off means nobody gets the new per-product experience regardless of SKUs.
 */
export const useIsComponentizationEnabled = (): boolean => {
  const publicConfig = useDynamicConfig('public_config');
  return publicConfig.get('enable_componentization', false);
};
